import { FormModel } from 'components/Form';
import { Validators } from 'utils/validators';

export type CallingFor = '' | 'EXISTING_CONTACT' | 'NEW_PROSPECT';

const commonFields = (strings: any, followUpModes: any[], isTask: boolean, type?: string): FormModel[] => [
  {
    label: strings.salesCallType,
    value: '',
    size: 'medium',
    type: 'drop-down',
    variant: 'outlined',
    placeholder: '',
    field: 'followUpMode',
    validators: [{ check: Validators.validateMandatoryField }],
    responsive: { xs: 12, sm: 6 },
    required: true,
    options: followUpModes,
    disabled: type === 'cold' ? false : isTask,
  },
  {
    label: strings.title,
    value: '',
    size: 'medium',
    type: 'text',
    typeValue: 'text',
    variant: 'outlined',
    placeholder: '',
    field: 'title',
    validators: [{ check: Validators.validateMandatoryField }],
    responsive: { xs: 12 },
    required: true,
    disabled: isTask,
  },
  {
    label: strings.description,
    value: '',
    typeValue: 'textarea',
    type: 'text',
    placeholder: '',
    field: 'description',
    validators: [{ check: Validators.validateMandatoryField }, { check: Validators.validateString }],
    required: true,
    responsive: { xs: 12 },
    rows: 2,
    multiline: true,
    size: 'medium',
    variant: 'outlined',
    disabled: isTask,
  },
];

export const AddEditSalesCallsForm = (
  strings: any,
  companyMasterList: any[],
  branchesList: any[],
  contactsList: any[],
  isTask: boolean,
  followUpModes: any[],
  callingFor?: CallingFor,
): FormModel[] => {
  if (!callingFor) {
    return [];
  }

  if (callingFor === 'EXISTING_CONTACT') {
    return [
      {
        label: strings.lead,
        value: '',
        size: 'medium',
        type: 'select',
        variant: 'outlined',
        placeholder: '',
        field: 'companyMaster',
        validators: [{ check: Validators.validateMandatoryField }],
        responsive: { xs: 12, sm: 6 },
        required: true,
        options: companyMasterList,
        disabled: isTask,
      },
      {
        label: strings.sales_company_branch_name,
        value: '',
        size: 'medium',
        type: 'drop-down',
        variant: 'outlined',
        placeholder: '',
        field: 'companyBranch',
        validators: [{ check: Validators.validateMandatoryField }],
        responsive: { xs: 12, sm: 6 },
        required: true,
        options: branchesList,
        disabled: branchesList.length === 0 || isTask,
      },
      {
        label: strings.contactedWith,
        value: '',
        size: 'medium',
        type: 'select',
        isMulti: true,
        isClearable: true,
        variant: 'outlined',
        placeholder: '',
        field: 'contactedWith',
        validators: [{ check: Validators.validateMandatoryField }],
        responsive: { xs: 12, sm: 6 },
        required: true,
        options: contactsList,
        disabled: contactsList.length === 0 || isTask,
      },
      ...commonFields(strings, followUpModes, isTask),
    ];
  }

  // NEW_PROSPECT
  return [
    {
      label: strings.sales_call_prospect_name,
      value: '',
      size: 'medium',
      type: 'text',
      typeValue: 'text',
      variant: 'outlined',
      placeholder: '',
      field: 'prospectName',
      validators: [{ check: Validators.validateMandatoryField }],
      responsive: { xs: 12, sm: 6 },
      required: true,
      // disabled: isTask,
    },
    {
      label: strings.sales_call_prospect_email,
      value: '',
      size: 'medium',
      type: 'text',
      typeValue: 'text',
      variant: 'outlined',
      placeholder: '',
      field: 'prospectEmail',
      validators: [{ check: Validators.validateEmail }],
      responsive: { xs: 12, sm: 6 },
      required: false,
      // disabled: isTask,
    },
    {
      label: strings.sales_call_prospect_phone,
      value: '',
      size: 'medium',
      type: 'text',
      typeValue: 'text',
      variant: 'outlined',
      placeholder: '',
      field: 'prospectPhone',
      validators: [{ check: Validators.validateMobile }],
      responsive: { xs: 12, sm: 6 },
      required: false,
      // disabled: isTask,
    },
    {
      label: strings.sales_call_prospect_company_name,
      value: '',
      size: 'medium',
      type: 'text',
      typeValue: 'text',
      variant: 'outlined',
      placeholder: '',
      field: 'prospectCompanyName',
      validators: [],
      responsive: { xs: 12, sm: 6 },
      required: false,
      // disabled: isTask,
    },
    {
      label: strings.sales_call_prospect_designation,
      value: '',
      size: 'medium',
      type: 'text',
      typeValue: 'text',
      variant: 'outlined',
      placeholder: '',
      field: 'prospectDesignation',
      validators: [],
      responsive: { xs: 12, sm: 6 },
      required: false,
      // disabled: isTask,
    },
    ...commonFields(strings, followUpModes, isTask, 'cold'),
  ];
};
